import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';

import { SwitchAlgorithmFacade } from './switch-algorithm.facade';
import { AlgorithmSelectorComponent } from '../../pipelines/algorithm-selector/algorithm-selector.component';

@Component({
  selector: 'ts-algorithm-switcher',
  templateUrl: './algorithm-switcher.component.html',
  styleUrls: ['./algorithm-switcher.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatCheckboxModule, TranslateModule, AlgorithmSelectorComponent],
})
export class AlgorithmSwitcherComponent {
  constructor(private readonly facade: SwitchAlgorithmFacade) {}

  public readonly options$ = this.facade.algorithmOptions$;
  public readonly selectedAlgorithm$ = this.facade.selectedAlgorithm$;
  public readonly loaded$ = this.facade.loaded$;
  public readonly initialSearchTerm$ = this.facade.initialSearchTerm$;
  public readonly hintKey$ = this.facade.hintKey$;

  public readonly deprecatedWarning$ = this.facade.deprecatedWarning$;
  public readonly compatibilityWarning$ = this.facade.compatibilityWarning$;
  public readonly mismatchedLabels$ = this.facade.mismatchedLabels$;

  public readonly algorithmListError$ = this.facade.algorithmListError$;
  public readonly compatibilityError$ = this.facade.compatibilityError$;

  switchToAlgorithm(algorithmId: string | null | undefined) {
    this.facade.switchToAlgorithm(algorithmId ?? undefined);
  }

  onLastItemReached() {
    this.facade.loadMoreAlgorithms(undefined);
  }

  includeDeprecatedChanged(includeDeprecated: boolean) {
    this.facade.setIncludeDeprecated(includeDeprecated);
  }

  searchAlgorithm(term: string) {
    this.facade.setSearchTerm(term);
  }
}
